<template>
  <layout-private>
    <div class="row appt-select">

      <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1">
        <hr class="hr-salmon">
        <h1>Today's Appointments</h1>

        <p class="loading" v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
        <p class="loading" v-if="!loading && !todaysAppointments"><em>No appointments are scheduled today.</em></p>

        <appointment-status-btn  v-if="!loading && todaysAppointments && upcomingAppointments && upcomingAppointments.length" v-for="appt in upcomingAppointments" :key="appt.AptNum" class="" :appointment="appt" :encounter="apptEncounter(appt.AptNum)"  @click.native="selectAppointment(appt)" />

        <h2 v-if="!loading && todaysAppointments && pastAppointments && pastAppointments.length" class="title-past">Today's Past Appointments</h2>

        <appointment-status-btn  v-if="!loading && todaysAppointments && pastAppointments && pastAppointments.length" v-for="appt in pastAppointments" :key="appt.AptNum" class="" :appointment="appt" :encounter="apptEncounter(appt.AptNum)"  @click.native="selectAppointment(appt)" />
        <hr class="hr-green">
      </div> <!-- /.col -->
    
    </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import ListErrors from '../components/ListErrors.vue'
import AppointmentStatusBtn from '../components/AppointmentStatusBtn.vue'
import moment from 'moment-timezone';

export default {
  props: ['customer'],
  components: {
    LayoutPrivate, ListErrors, AppointmentStatusBtn,
  },
  data() {
    return {
      todaysAppointments: null,
      loading: false,
      loadingEncounters: false,
      todaysEncounters: null,
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims']),
    // Appointments after current time of day (upcoming)
    upcomingAppointments() {
      if (!this.todaysAppointments || !this.todaysAppointments.length) return [];
      const now = new Date();
      return this.todaysAppointments
        .filter(appt => {
          const apptDate = new Date(appt.AptDateTime);
          return apptDate >= now;
        })
        .sort((a, b) => new Date(a.AptDateTime) - new Date(b.AptDateTime));
    },
    // Appointments prior to current time of day (past)
    pastAppointments() {
      if (!this.todaysAppointments || !this.todaysAppointments.length) return [];
      const now = new Date();
      return this.todaysAppointments
        .filter(appt => {
          const apptDate = new Date(appt.AptDateTime);
          return apptDate < now;
        })
        .sort((a, b) => new Date(b.AptDateTime) - new Date(a.AptDateTime));
    },
    aptDateStamp() {
      return moment.tz('America/Chicago').format("YYYYMMDD");
    },
  },
  watch: {
    custom_claims(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchTodaysAppointments();
        this.fetchTodaysEncounters();
      }
    },
  },
  methods: {
    apptEncounter(apptNum) {
      if(this.todaysEncounters && this.todaysEncounters[apptNum]) {
        return this.todaysEncounters[apptNum];
      }
      return null;
    },
    selectAppointment(appt) {
      // console.log('Selected appointment:', appt);
      // Update appointment in Vuex store
      this.$store.dispatch('updateAppointment', appt);
      // update patnum in Vuex store
      this.$store.dispatch('updatePatNum', appt.PatNum);
      // Navigate to encounter type selection
      this.$router.push({ name: 'appointmentSetup' });
    },
    async fetchTodaysAppointments() {
      const uid = this.user?.uid;
      const customerId = this.custom_claims?.customerId;
      const locationId = this.custom_claims?.authorized_location;
      if (!uid || !customerId || !locationId) {
        // Required parameters missing, exit early
        return;
      }
      this.loading = true;
      try {
        const loadAppointments = Vue.functions.httpsCallable('loadTodaysAppointments');
        const payload = { uid, customerId, locationId };
        const result = await loadAppointments(payload);
        if(result.data && Array.isArray(result.data) && result.data.length) {
          this.todaysAppointments = result.data;
        }
      } catch (err) {
        console.error("Failed to load today's appointments:", err);
        this.todaysAppointments = null;
      }
      this.loading = false;
    },
    // write function to load all encounters for today from firestore
    async fetchTodaysEncounters() {
      const uid = this.user?.uid;
      const customerId = this.custom_claims?.customerId;
      const locationId = this.custom_claims?.authorized_location;
      if (!uid || !customerId || !locationId) {
        // Required parameters missing, exit early
        return;
      }
      this.loadingEncounters = true;
      try {
        const snapshots = await Vue.firestore
          .collection(`customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/encounters`)
          .where('datestamp', '==', this.aptDateStamp)
          .get();
        
        if(!snapshots.empty) {
          // convert snapshots to an index of encounter data
          const encounters = {};
          snapshots.forEach(doc => {
            if(doc.data().appointment_num) {
              encounters[doc.data().appointment_num] = doc.data();
            }
          });
          this.todaysEncounters = encounters;
        } else {
          console.log('No encounters found for today');
        }
      } catch (err) {
        console.error("Failed to load today's encounters:", err);
        this.todaysEncounters = null;
      }
      this.loadingEncounters = false;
    },
  },
  mounted() {
    this.fetchTodaysAppointments();
    this.fetchTodaysEncounters();
  },
  
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.appt-select {
  padding-top: 55px;
}
.hr-salmon {
  margin-top: 0;
}
.title-past {
  margin-top: 60px;
}

</style>
